import React from 'react';

const RideHistoryTable = ({ rides, startEntry, endEntry }) => {
  return (
    <div className='card-body'>
      <div className='table-responsive'>
        <table className='table'>
          <thead>
            <tr>
              {[
                'Employee',
                'Pickup Location',
                'Dropoff Location',
                'Date and Time',
                'Cab #',
                'Cost',
                'Status',
              ].map((header, index) => (
                <th
                  key={index}
                  style={{
                    borderBottom: '1px solid #e5e5e5',
                    color: '#969696',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rides.slice(startEntry - 1, endEntry).map((ride, index) => (
              <tr key={index} style={{ borderBottom: '1px solid #e5e5e5' }}>
                <td
                  className='py-3'
                  style={{ fontSize: '14px', fontWeight: '500' }}
                >
                  {ride.employee}
                </td>
                <td
                  className='py-3'
                  style={{ fontSize: '14px', fontWeight: '500' }}
                >
                  {ride.pickup}
                </td>
                <td
                  className='py-3'
                  style={{ fontSize: '14px', fontWeight: '500' }}
                >
                  {ride.destination}
                </td>
                <td
                  className='py-3'
                  style={{ fontSize: '14px', fontWeight: '500' }}
                >
                  {ride.pickupTime}
                </td>
                <td
                  className='py-3'
                  style={{ fontSize: '14px', fontWeight: '500' }}
                >
                  {ride.status === 'Booked' ? ride.vehicle_number : 'N/A'}
                </td>
                <td
                  className='py-3'
                  style={{ fontSize: '14px', fontWeight: '500' }}
                >
                  {ride.fare ? `€${ride.fare}` : 'N/A'}
                </td>
                <td
                  className='py-3'
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: ride.status === 'Completed' ? 'green' : 'red',
                  }}
                >
                  {ride.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RideHistoryTable;
